
import { supabase } from "@/integrations/supabase/client";

interface SignUpUserData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export const signUpUser = async (userData: SignUpUserData) => {
  const { data: authData, error: authError } = await supabase.auth.signUp({
    email: userData.email,
    password: userData.password,
    options: {
      emailRedirectTo: `${window.location.origin}/marketplace`,
      data: {
        first_name: userData.firstName,
        last_name: userData.lastName
      }
    }
  });

  if (authError) throw authError;
  return authData;
};

export const isInitDone = async (userId: string) => {
  const { data, error} = await supabase
    .from('user_roles')
    .select('isInitDone')
    .eq('user_id', userId)
    .single();

  if(error){
    return false;
  }
  return data?.isInitDone??false;
}

export const setIsInitDone = async (userId: string, campaign: string) => {
  const updateData = {
    campaign: null,
    user_id: userId
  };

  if(campaign){
    updateData.campaign = campaign;
  }

  const { data, error } =  await supabase.functions.invoke('set-init-done-for-user', { 
    body: updateData
  });

    if(error)
    {
      console.log("ERROR: ", error);
    }
  return error? false: true;
}

export const subscribeToKlaviyo = async (userId: string, email: string, firstName: string, lastName: string) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      console.error("No active session found for Klaviyo subscription");
      return;
    }

    const { data, error } = await supabase.functions.invoke('klaviyo-subscribe', {
      body: { userId, email, firstName, lastName },
      headers: {
        Authorization: `Bearer ${session.access_token}`
      }
    });
    
    if (error) {
      console.error("Error subscribing to Klaviyo:", error);
    } else {
      console.log("Successfully subscribed to Klaviyo:", data);
    }
  } catch (err) {
    console.error("Exception during Klaviyo subscription:", err);
  }
};
